import { createFileRoute } from '@tanstack/react-router';

import { getCompetitorQueryOptions } from '@/_pages/competitors/api-service';
import Loading from '@/_pages/competitors/associated-companies/loading';

export const Route = createFileRoute('/_private/competitors/_template/$id/associated-companies')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getCompetitorQueryOptions(opts.params.id)),
  staticData: {
    pageTitle: 'Associated Companies',
    tabKey: 'competitor/associated-companies',
  },
  pendingComponent: Loading,
});
